import { frameworkEditorPlugin } from '@/framework/plugins';
import { layerPlugin } from '@/layers/layer';
import { IRegisterPluginOptions } from '@/version-types';

/** 加载内置插件 */
export function loadInnerPlugins(registerPlugins: (configs: IRegisterPluginOptions[]) => void) {
    registerPlugins([{ plugin: layerPlugin }, { plugin: frameworkEditorPlugin }]);
}
